<template>
    <DashboardGraph :icons="icons" :title="title" :chart_type="chart_type" :chart_handle="chart_layout" :load_url="load_url" :options="options" :options_text="options_text"></DashboardGraph>
</template>

<script>
    import DashboardGraph from '../../widgets/DashboardGraph';
    export default {
        name: 'NewLeads',
        components: {DashboardGraph},
        data() {
            var labels = [];
            for(var i = 8; i <= 17;i++){
                labels[i-8] = 'Hour '+i;
            }
            return {
                icons:labels,
                chart_type: 'line',
                color: '#2129d5',
                title: 'New Leads',
                load_url: '/dashboards/newLeads',
                time_wait: 10000,
                options: ['today','yesterday','last7days','this_month','last_month'],
                options_text: ['Today','Yesterday','Last 7 Days','This Month','Last Month'],
                chart_layout: [
                    {
                        'label': 'Today\'s Leads',
                        'backgroundColor': 'rgba(220, 220, 220, 0)', //can be an array for other graph types
                        'borderColor': '#00b',
                        'pointBackgroundColor': 'rgba(220, 220, 220, 0)',
                        'pointBorderColor': '#fff',
                        'pointHighlightFill': 'rgba(220, 220, 220, 0)',
                        'pointHighlightStroke': 'rgba(220, 220, 220, 0)',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>